import {
  DeleteOutlined,
  EditOutlined,
  PlusOutlined
} from '@ant-design/icons'
import { Button, Form, Space, Tooltip } from 'antd'
import get from 'lodash.get'
import React, { useEffect, useState } from 'react'
import { convertPriceToNumber, formatCurrencyLabel, formatCurrencyUnit, hasPermission } from '../../config-func'
import {
  ACTION_MODE,
  PAGE_SIZE_OPTIONS
} from '../../configData'
import {
  listRechargePromotion,
  rechargePromotionAdd,
  rechargePromotionDelete,
  rechargePromotionDetail,
  rechargePromotionUpdate
} from '../../services/recharge-promotion'
import Card from '../Card'
import ModalCustom from '../common/Modal/ModalCustom'
import ModalConfirm, { showConfirm } from '../common/ModalConfirm/ModalConfirm'
import openNotification from '../common/Notification/openNotification '
import TableField from '../common/Table/TableField'
import FilterForm from './FilterForm'
import FormPost from './FormPost'
import dayjs from 'dayjs'
import Loading from '../Loading';
const RechargePromotions = () => {
  const permissions = JSON.parse(localStorage.getItem('permissions') || '[]')
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [mode, setMode] = useState(ACTION_MODE.VIEW)
  const [form] = Form.useForm()
  const [dataSource, setDataSource] = useState([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(false)

  const [filters, setFilters] = useState({
    currentPage: 1,
    pageSize: 10
  })

  const handleSearch = () => {
    if (filters.currentPage === 1) {
      fetchData()
    } else {
      setFilters((prev) => ({ ...prev, currentPage: 1 }))
    }
  }

  async function fetchData() {
    setLoading(true)

    let _dataSource = []
    let _total = 0

    const params = {
      page: filters.currentPage,
      pageSize: filters.pageSize,
      title: filters.title || '',
    }

    const cleanedData = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== '' && value !== null && value !== undefined
      )
    )

    try {
      const response = await listRechargePromotion(cleanedData)
      _total = response?.data?.total
      _dataSource = response?.data?.list
      // }
    } catch (error) {
      openNotification('error', error?.response?.data?.message || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
      setTotal(_total)
      setDataSource(_dataSource)
    }
  }

  useEffect(() => {
    fetchData()
  }, [filters.currentPage, filters.pageSize, filters.reset])
  // -=0-=0-====================================================================================================
  // Columns for Table
  const initialColumns = [
    {
      title: 'STT',
      dataIndex: 'stt',
      key: 'stt',
      fixed: 'left',
      width: 60,
      align: 'center',
      render: (_, __, index) =>
        (filters.currentPage - 1) * filters.pageSize + index + 1
    },
    {
      title: 'Tiêu đề',
      dataIndex: 'title',
      key: 'title',
      width: 200,
    },
    {
      title: 'Giảm giá',
      dataIndex: 'preferential',
      key: 'preferential',
      width: 150,
      render: (_, record) => <span>{record.preferential} %</span>
    },
    {
      title: 'Giá bắt đầu',
      dataIndex: 'price_from',
      key: 'price_from',
      width: 150,
      render: (_, record) => <span>{formatCurrencyLabel(record.price_from,{ compact: true })}</span>
    },
    {
      title: 'Giá kết thúc',
      dataIndex: 'price_to',
      key: 'price_to',
      width: 150,
      render: (_, record) => <span>{formatCurrencyLabel(record.price_to, { compact: true })}</span>
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'created_at',
      key: 'created_at',
      width: 150,
      render: (_, record) => dayjs.unix(record.created_at).format('DD/MM/YYYY')
      // render: (_, record) => <span>{dayjs(record.created_at).format('DD/MM/YYYY')}</span>
    },
    // {
    //   title: 'Trạng thái',
    //   dataIndex: 'status',
    //   key: 'status',
    //   render: (_, record) => <Switch checked={record.status === 1} />
    // },

    {
      title: 'Hành động',
      key: 'status',
      fixed: 'right',
      width: 150,
      render: (_, record) => {
        return (
          <Space size="small">
            <>
            {hasPermission('P48.2', permissions) && (
              <Tooltip title="Chỉnh sửa">
                <Button
                  style={{ width: 32 }}
                  icon={<EditOutlined />}
                  onClick={() => {
                    setMode(ACTION_MODE.UPDATE)

                    setIsModalOpen(true)
                    form.setFieldsValue({
                      ...record
                    })
                  }}
                />
              </Tooltip>
              )}
              {hasPermission('P48.3', permissions) && (
              <Tooltip title="Xóa">
                <Button
                  style={{ width: 32 }}
                  icon={<DeleteOutlined style={{ color: 'red' }} />}
                  onClick={() =>
                    showConfirm({
                      title: 'Xác nhận xóa',
                      content: (
                        <div>
                          Bạn có chắc chắn muốn xóa <b>{record.name}</b>
                        </div>
                      ),
                      onOk: () => handleDelete(record.id)
                    })
                  }
                />
              </Tooltip>
              )}
            </>
          </Space>
        )
      }
    }
  ]

  // Thêm sửa project
  const handleSave = async () => {
    setLoading(true)
    try {
      // Validate các trường trong form
      const values = await form.validateFields()
      // Kiểm tra nếu cả hai giá trị đều tồn tại
      const { id, ...data } = values
      const dataUpdate = {
        ...data,
        price_from: data.price_from ? convertPriceToNumber(data.price_from.toString()) : 0,
        price_to: data.price_to ? convertPriceToNumber(data.price_to.toString()) : 0
      }
      const res =
        mode == ACTION_MODE.ADD
          ? await rechargePromotionAdd(dataUpdate)
          : await rechargePromotionUpdate(dataUpdate, id)

      form.resetFields()
      setIsModalOpen(false)
      fetchData()
      openNotification(
        'success',
        mode == ACTION_MODE.ADD
          ? 'Tạo mới gói nạp tiền & khuyến mãi thành công !'
          : 'Cập nhật gói nạp tiền & khuyến mãi thành công !'
      )
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  // Xóa project
  const handleDelete = async (id) => {
    // const body = {
    //   ids: [ids]
    // }
    setLoading(true)
    try {
      const res = await rechargePromotionDelete(id)
      fetchData()
      openNotification('success', res.message)
    } catch (err) {
      const errors = get(err, 'response.data.data', [])
      const errorMessages =
        errors?.map((error) => error.message).join('\n') ||
        get(err, 'response.data.message', [])
      openNotification('error', errorMessages || 'Đã có lỗi xảy ra')
    } finally {
      setLoading(false)
    }
  }

  //
  return (
    <div>
      <Loading loading={loading} />
      <Card className="mb-2">
        <FilterForm
          handleSearch={handleSearch}
          setFilters={setFilters}
          fetchData={fetchData}
        />
      </Card>

      <Card>
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            margin: '0px 50px 10px 0px',
            width: '100%'
          }}
        >
          {/* <h2 className="text-2xl font-semibold my-2">Quản lý dự án</h2> */}
          <div style={{ marginLeft: 'auto', display: 'flex', gap: '8px' }}>
            {/* <Button
              type="primary"
              key="primary"
              onClick={() => {
                setIsModalImportOpen(true)
              }}
            >
              <PlusOutlined /> Import Excel
            </Button> */}

            {hasPermission('P48.1', permissions) && (
            <Button
              type="primary"
              // htmlType="submit"
              onClick={() => {
                setIsModalOpen(true)
                setMode(ACTION_MODE.ADD)
              }}
            >
              <PlusOutlined />
              Thêm mới
            </Button>
            )}
          </div>
        </div>
        <TableField
          loading={loading}
          columns={initialColumns}
          dataSource={dataSource}
          scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
          className={`custom-table`}
          // locale={{
          //   emptyText: <Empty description="Không có dữ liệu" />, // Hiển thị "Không có dữ liệu" khi bảng không có dữ liệu
          //   triggerDesc: 'Sắp xếp giảm dần', // Khi click vào cột để sort giảm dần
          //   triggerAsc: 'Sắp xếp tăng dần', // Khi click vào cột để sort tăng dần
          //   cancelSort: 'Hủy sắp xếp' // Khi bỏ sắp xếp
          // }}

          // columns={
          //   filters.isDefault === 'fixed'
          //     ? columns.filter(
          //         (item) => !['calculationMethod'].includes(item.dataIndex)
          //       )
          //     : columns.filter(
          //         (item) => !['isDefault'].includes(item.dataIndex)
          //       )
          // }

          pagination={{
            current: filters.currentPage,
            pageSize: filters.pageSize,
            total: total,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showSizeChanger: true,
            onShowSizeChange: (current, size) => {
              setFilters((prev) => ({
                ...prev,
                pageSize: size,
                currentPage: 1
              }))
            },
            onChange: (page) => {
              setFilters((prev) => ({ ...prev, currentPage: page }))
            },
            showTotal: (total, range) => `Hiển thị ${range[0]}-${range[1]} của ${total} bản ghi`,
            locale: { items_per_page: 'bản ghi / trang' }
          }}
          rowKey={(record, index) => index}
          locale={{ emptyText: 'Không có dữ liệu' }}
        />
      </Card>
      {/* Modal Thêm mới sản phẩm */}
      <ModalCustom
        title={
          mode == ACTION_MODE.UPDATE
            ? 'Chỉnh sửa gói nạp tiền & khuyến mãi'
            : mode == 'ADD'
            ? 'Thêm mới gói nạp tiền & khuyến mãi'
            : 'Xem chi tiết'
        }
        visible={isModalOpen}
        centered
        onCancel={() => {
          setIsModalOpen(false)
          form.resetFields()
        }}
        onConfirm={async () => {
          try {
            await form.validateFields() // Kiểm tra validation trước khi tiếp tục
            handleSave() // Nếu hợp lệ thì tiếp tục xử lý
          } catch (error) {
            console.log('Validation failed:', error)
          }
        }}
        confirmText={'Lưu'}
        cancelText="Đóng"
        footer={mode == 'VIEW' ? [''] : ''}
      >
        <FormPost form={form} handleSearch={handleSearch} mode={mode} />
      </ModalCustom>
      <ModalConfirm />
    </div>
  )
}

export default RechargePromotions
